import { getVerificationByTxnId } from '@api/form-verification';
import { BGV_PREFIX } from '@global/constants/general';
import { TxnState } from '@global/constants/verification';
import { mixpanel, trackingEvents } from '@global/monitoring/mixpanel';
import { VerificationState } from '@global/types/form';
import { updateMiscStore } from '@redux/slices/misc';
import { store } from '@redux/store';
import { navigateTo } from '@services/navigation';

export const EDUCATION_VERIFICATION_NAMES: Record<
  string,
  keyof typeof trackingEvents.education.events
> = {
  'bgv-degree': 'degree',
  'bgv-twelfth': 'twelveth',
  'bgv-tenth': 'tenth'
};

export const updateCurrentVerificationInStore = (name: string) => {
  store.dispatch(updateMiscStore({ currentVerification: name }));
};

export const verificationTileOnClick = async (row: VerificationState) => {
  let res;
  const getDataReqd = [TxnState.COMPLETED, TxnState.FAILED, TxnState.INSUFFICIENT_DATA].includes(
    row?.state
  );
  const { orgInfo = {}, txnId } = store.getState()?.formData ?? {};
  const isBGV = row?.name?.includes(BGV_PREFIX);
  if ((isBGV && !row.acceptMultipleSubmissions && getDataReqd) || !isBGV) {
    res = await getVerificationByTxnId(txnId, orgInfo?.orgId, row?.name);
    if ((isBGV && [TxnState.COMPLETED, TxnState.FAILED].includes(row?.state)) || !isBGV) {
      if (res?.code === 0) {
        if (isBGV) {
          const foundVerification = res?.data?.find((r: any) => r?.subType === row?.subType);
          if (foundVerification) {
            updateCurrentVerificationInStore(row?.name);
            navigateTo('/verification-info', {
              state: {
                data: {
                  request: foundVerification?.request?.data,
                  verificationName: row?.name
                },
                entireVerificationTxnData: foundVerification,
                state: row?.state
              }
            });
          }
        } else {
          if (
            [TxnState.COMPLETED, TxnState.FAILED].includes(row?.state) ||
            res?.data?.[0]?.responseList?.[0]?.presentation?.length > 0
          ) {
            updateCurrentVerificationInStore(row?.name);
            navigateTo('/verification-info', {
              state: {
                data: {
                  attributes: res?.data?.[0]?.responseList?.[0]?.presentation,
                  verificationName: row?.name
                },
                state: TxnState.COMPLETED
              }
            });
          }
        }
      }
      if (
        [TxnState.COMPLETED, TxnState.FAILED].includes(row?.state) ||
        (!isBGV && res?.data?.[0]?.responseList?.[0]?.presentation?.length > 0)
      ) {
        return;
      }
    }
    if (row?.state === TxnState.INSUFFICIENT_DATA) {
      if (res?.code === 0) {
        updateCurrentVerificationInStore(row?.name);
        navigateTo(`/verification/insufficiency`, {
          state: {
            request: res?.data?.[0]?.request,
            responseList: res?.data?.[0]?.responseList,
            subType: res?.data?.[0]?.subType
          }
        });
      }
      return;
    }
  }
  const eduKey = EDUCATION_VERIFICATION_NAMES[row?.name];
  if (eduKey) {
    const eduGroup = trackingEvents.education.events[eduKey] as {
      panelOpened: string,
      detailsEntered: string,
      uploadCompleted: string
    };
    mixpanel.track(eduGroup.panelOpened, {
      verification: row?.name,
      document_type: eduKey
    });
  }
  updateCurrentVerificationInStore(row?.name);
  navigateTo(`/verification`, {
    state: {
      verificationName: row?.name
    }
  });
};
